import { render, staticRenderFns } from "./SchemeTypePaymentList.vue?vue&type=template&id=ffca6040"
import script from "./SchemeTypePaymentList.vue?vue&type=script&lang=js"
export * from "./SchemeTypePaymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports